import { Nullable } from 'types'

export const normalizeNumber = (value: string | number) =>
  trimLeadingZeros(value.toString().replace(/[^0-9]/g, ''))

export const trimLeadingZeros = (input: string) => {
  let trimmed = input.replace(/^0+/, '')

  if (trimmed === '') {
    return '0'
  }

  if (trimmed.includes(',')) {
    trimmed = trimmed.replace(',', '.')
  }

  if (trimmed.startsWith('.')) {
    trimmed = '0' + trimmed
  }

  if (trimmed.endsWith('.')) {
    trimmed += '0'
  }

  return trimmed
}

export const scrollToInput = (
  container: Nullable<Element>,
  element: Nullable<HTMLInputElement | HTMLTextAreaElement>,
  offset = 50,
) => {
  if (!container || !element) return

  setTimeout(() => {
    const containerRect = container.getBoundingClientRect()
    const elementRect = element.getBoundingClientRect()

    const scrollTop = elementRect.top - containerRect.top + container.scrollTop - offset

    container.scrollTo({ top: scrollTop, left: 0, behavior: 'smooth' })
  }, 500)
}
